import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { useProductDealerGroupDocumentProvider } from '../ProductDocument.DealerGroupDocuments.Hooks';
import DealerGroup from 'models/dealerManagement/dealerGroup/Model.DealerGroup';
import UploadDocumentTranslationButton from '../../../../components/translations/UploadDocumentTranslationButton';

export default function DealerGroupDocumentList() {
  const { lang } = getLocales();
  const {
    dealerGroupDocumentList,
    selectedItems,
    toggleItem,
    reloadTranslatedDocs,
    selectedTranslatedItems,
    toggleTranslatedItem,
    translatedDocumentList,
  } = useProductDealerGroupDocumentProvider();

  return dealerGroupDocumentList.count == 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.documents}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.dealerGroup}</th>
          <th>{lang.document}</th>
          <th>{lang.translations}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={dealerGroupDocumentList.data?.map((x) => ({ ...x, dealerGroup: new DealerGroup(x.dealerGroup) }))}
          render={({ data: productDealerGroupDocument }) => {
            const isDocumentSelected = selectedItems?.some(
              (it) => it.dealerGroupId === productDealerGroupDocument.dealerGroupId
            );

            const translations =
              translatedDocumentList?.filter((it) => it.documentId === productDealerGroupDocument.id) ?? [];
            const areTranslationsSelected = translations?.every((it) =>
              selectedTranslatedItems.some((t) => t.id === it.id)
            );
            return (
              <tr key={productDealerGroupDocument.dealerGroupId}>
                <td>
                  <b>{productDealerGroupDocument.dealerGroup.displayInfo.title}</b>
                </td>
                <td>{productDealerGroupDocument.mediaFile?.name ?? '-'}</td>
                <td>
                  <UploadDocumentTranslationButton
                    documentId={productDealerGroupDocument.id}
                    documentType="ProductDealerGroupDocument"
                    translatedDocuments={translations}
                    onFinish={reloadTranslatedDocs}
                  />
                </td>
                <td>
                  <Box class={ThemeWrapperStack}>
                    <Button
                      data={productDealerGroupDocument}
                      onClick={toggleItem}
                      class={ThemeButtonCircle}
                      media={<Icon class={isDocumentSelected ? 'fas-check-square' : 'far-square'} />}
                      render="EN"
                      htmlElementProps={{ title: isDocumentSelected ? lang.unselect : lang.select }}
                      active
                    />
                    <Button
                      data={translations}
                      onClick={toggleTranslatedItem}
                      class={ThemeButtonCircle}
                      disabled={isDocumentSelected || !translations?.length}
                      media={
                        <Icon
                          class={
                            (areTranslationsSelected || isDocumentSelected) && translations?.length
                              ? 'fas-check-square'
                              : 'far-square'
                          }
                        />
                      }
                      render="FR"
                      htmlElementProps={{ title: areTranslationsSelected ? lang.unselect : lang.select }}
                      active
                    />
                  </Box>
                </td>
              </tr>
            );
          }}
        />
      </tbody>
    </table>
  );
}
